/**
 * Aprovação com a COTAÇÃO DO BANCO — Previsão Inter (Rafael, 28/09). Espelho de
 * App\Services\Financeiro\CambioBancoAprovacao::calcular (a API recalcula e grava; aqui é a prévia
 * do modal e a trava do botão — validação em 2 camadas).
 * R$ a pagar = valor na moeda × cotação + IOF + IR + taxa operacional (+ parte Brasil do fornecedor
 * misto, que fica em R$). IOF/IR em % incidem sobre o principal convertido.
 */
const r2 = (v) => Math.round((Number(v) + Number.EPSILON) * 100) / 100;

export const numeroCampo = (v) => {
    if (v === null || v === undefined || v === '') return 0;
    if (typeof v === 'number') return v;
    let s = String(v).trim();
    if (s.indexOf(',') !== -1) s = s.replace(/\./g, '').replace(',', '.');
    const n = Number(s);
    return Number.isFinite(n) ? n : NaN;
};

export const calcularCotacao = (base, entrada) => {
    const cotacao = numeroCampo(entrada.cotacao);
    const iof = numeroCampo(entrada.iof);
    const ir = numeroCampo(entrada.ir);
    const taxa = numeroCampo(entrada.taxa);
    const principal = r2(Number(base.valor_moeda || 0) * cotacao);
    const iofBrl = entrada.iofTipo === 'valor' ? r2(iof) : r2(principal * iof / 100);
    const irBrl = entrada.irTipo === 'valor' ? r2(ir) : r2(principal * ir / 100);
    const taxaBrl = r2(taxa);
    const brlNacional = r2(base.brl_nacional || 0);
    const total = r2(principal + brlNacional + iofBrl + irBrl + taxaBrl);
    return { principal, iofBrl, irBrl, taxaBrl, brlNacional, total };
};

/** Mensagem que trava o Confirmar (null = pode aprovar). */
export const pendenciaCotacao = (base, entrada) => {
    if (!base) return null;
    if (!base.pode_cotar) return base.erro && base.erro.indexOf('não tem valor em moeda estrangeira') === -1 ? base.erro : null;
    if (base.excede) return 'O plano passa do valor orçado na moeda do fornecedor. O Eventos precisa ajustar as parcelas.';
    const campos = { cotacao: 'Cotação', iof: 'IOF', ir: 'IR', taxa: 'Taxa operacional' };
    for (const k of Object.keys(campos)) {
        const n = numeroCampo(entrada[k]);
        if (!Number.isFinite(n) || n < 0) return campos[k] + ' inválido.';
    }
    if (!(numeroCampo(entrada.cotacao) > 0)) return 'Informe a cotação do câmbio trazida do banco.';
    if ((entrada.iofTipo !== 'valor' && numeroCampo(entrada.iof) > 100) || (entrada.irTipo !== 'valor' && numeroCampo(entrada.ir) > 100)) {
        return 'Percentual de IOF/IR acima de 100%.';
    }
    return null;
};
